import React from 'react';
import PropTypes from '@app/utils/propTypes';
import { Link } from 'react-router-dom';
import bn from '@app/utils/bemnames';

import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

import Typography from '@app/components/Typography';

const bem = bn.create('page');

const Page = ({
  title,
  breadcrumbs,
  tag: Tag,
  className,
  children,
  actionButton,
  ...restProps
}) => {
  const classes = bem.b('px-3', className);

  return (
    <Tag className={classes} {...restProps}>
      <div className={bem.e('header')}>
        {title && typeof title === 'string' ? (
          <Typography tag="h1" type="h1" className={bem.e('title')}>
            {title}
          </Typography>
        ) : (
            title
          )}
        <div className="d-flex justify-content-between align-items-center w-100">
          {breadcrumbs && (
            <Breadcrumb className={`${bem.e('breadcrumb')} ${breadcrumbs.some(b => String(b.name).includes('pWAN')) ? 'preserve-pwans' : ''}`}>
              <BreadcrumbItem>
                <Link to="/dashboard">Home</Link>
              </BreadcrumbItem>
              {breadcrumbs.length &&
                breadcrumbs.map(({ name, active, url, to }, index) => (
                  <BreadcrumbItem key={index} active={active}>
                    {active ? (
                      name
                    ) : to ? (
                      <Link to={to}>{name}</Link>
                    ) : url ? (
                      <a href={url}>{name}</a>
                    ) : (
                      name
                    )}
                  </BreadcrumbItem>
                ))}
            </Breadcrumb>
          )}
          {actionButton}
        </div>
      </div>
      {children}
    </Tag>
  );
};

Page.propTypes = {
  tag: PropTypes.component,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  children: PropTypes.node,
  actionButton: PropTypes.element,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      active: PropTypes.bool,
      url: PropTypes.string,
      to: PropTypes.string,
    })
  ),
};

Page.defaultProps = {
  tag: 'div',
  title: '',
};

export default Page;
